<template>
  <v-app>
    <!-- <v-main> -->
    <router-view></router-view>
    <!-- </v-main> -->
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    showNav: false,
    notiCount: 0
  }),

  mounted() {},
  watch: {
    "$i18n.locale"() {
      let self = this;
      let cur_lang = self.$i18n.locale;
      if (cur_lang == "mm" || cur_lang == "cn") {
        document.documentElement.style.setProperty("--f-s", "7px");
      } else {
        document.documentElement.style.setProperty("--f-s", "0px");
      }
    }
  }
};
</script>
<style>
@font-face {
  font-family: "Kanit";
  src: url("./assets/vendor/fontawesome/webfonts/Kanit-Regular.ttf");
}
</style>
